import CornerMedium from "../../icons/CornerMedium";
import CornerSmall from "../../icons/CornerSmall";
import CornerLarge from "../../icons/CornerLarge";
import { PaginationTypes } from "@Shared/Pagination-Types";
import { PeopleVariants } from "../people/defaults";

export const TabsSettings = [
  { label: "Layout", value: "layout", i18n: "layout" },
  { label: "Content", value: "content", i18n: "content" },
];

export const VariantOptions = [
  { label: "Card", value: PeopleVariants.CARD },
  { label: "List", value: PeopleVariants.LIST },
];

export const getPaginationOptions = (t) => ([
  { label: t("none"), value: PaginationTypes.NONE },
  { label: t("show-more"), value: PaginationTypes.INFINITE },
  { label: t("previous-or-next"), value: PaginationTypes.CAROUSEL },
]);

export const CORNERS_OPTIONS = [
  { icon: CornerSmall, value: 1 },
  { icon: CornerMedium, value: 8 },
  { icon: CornerLarge, value: 32 },
];

export const BOOLEAN_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];

export const CONTENT_FILTERS = {
  BLOG_CREATED: "blog-created",
  BLOG_UPDATED: "blog-updated",
  PAGE_CREATED: "page-created",
  PAGE_UPDATED: "page-updated",
  COMMENT_POSTED: "comment-posted",
};
